import { render, staticRenderFns } from "./RiskEvaluationFinalPart.vue?vue&type=template&id=1bcb2aa2"
import script from "./RiskEvaluationFinalPart.vue?vue&type=script&lang=js"
export * from "./RiskEvaluationFinalPart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports